import React, { useEffect, useState } from "react";
import {
  Flex,
  Form,
  Input,
  Menu,
  message,
  Button,
  Image,
  DatePicker,
  Modal,
  Pagination,
  Dropdown,
  Space,
  Upload,
  Popconfirm,
} from "antd";
import Header from "../components/Header/Header";
import MyText from "../../components/UI/Text/MyText";
import classes from "../global_styles.module.css";
import FormItem from "antd/es/form/FormItem";
import IntlMessage from "../../components/IntlMessage/IntlMessage";
import { Link, useNavigate } from "react-router-dom";
import { clrs } from "../../constants/colors";
import Footer from "../components/Footer/Footer";
import { useSelector } from "react-redux";
import ProfessionService from "../../services/ProfessionService";
import {
  EyeOutlined,
  FilterOutlined,
  LogoutOutlined,
  SortAscendingOutlined,
  SortDescendingOutlined,
  UserOutlined,
  UsergroupAddOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import AdminApplicationService from "../../services/AdminApplicationService";
import profileImg from "../../images/abstract-user-flat-3.svg";
import HorizontalDivider from "../../components/Divider/HorizontalDivider";
import profileClasses from "./profile.module.css";
import BlockLoading from "../../components/LoadingComponents/BlockLoading";
import AdminProfileService from "../../services/AdminProfileService";
import CheckboxMenu from "./CheckboxMenu";
import AdminUserService from "../../services/AdminUserService";
import CheckboxMenuForStatus from "./CheckboxMenuForStatus";
import AdminSongoltPage from "./AdminSongolt";

const AdminProfilePage = () => {
  const navigate = useNavigate();
  const { user, isLoading } = useSelector((state) => state.user);

  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRecordId, setSelectedRecordId] = useState(null);

  const { Search } = Input;

  // eslint-disable-next-line no-unused-vars
  const [professionsList, setProfessionsList] = useState([]);

  const [applications, setApplications] = useState([]);

  useEffect(() => {
    // eslint-disable-next-line eqeqeq
    if (user == null && isLoading == false) {
      navigate("/login");
    }
  }, [user, isLoading, navigate]);

  const [currentMenu, setCurrentMenu] = useState("applications");

  const [selectedOrderProperty, setSelectedOrderProperty] = useState([
    "a.createdAt",
  ]);
  const [selectedOrderDirection, setSelectedOrderDirection] = useState([
    "desc",
  ]);

  useEffect(() => {
    if (!initLoading) {
      handleFetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrderProperty, selectedOrderDirection]);

  const orderItems = [
    {
      label: "Бүртгэлийн огноогоор",
      key: "a.createdAt",
      onClick: () => {
        setSelectedOrderProperty(["a.createdAt"]);
      },
    },
    {
      label: "Овог, нэрээр",
      key: "p.fullName",
      onClick: () => {
        setSelectedOrderProperty(["p.lastName", "p.firstName", "p.middleName"]);
      },
    },
    {
      label: "Сургуулиар",
      key: "p.school",
      onClick: () => {
        setSelectedOrderProperty(["p.school"]);
      },
    },
  ];
  const orderMenuProps = {
    items: orderItems,
    selectable: true,
    defaultSelectedKeys: ["a.createdAt"],
  };

  const orderDirectionItems = [
    {
      label: "Өсөх",
      key: "asc",
      icon: <SortAscendingOutlined />,
      onClick: () => {
        setSelectedOrderDirection(["asc"]);
      },
    },
    {
      label: "Буурах",
      key: "desc",
      icon: <SortDescendingOutlined />,
      onClick: () => {
        setSelectedOrderDirection(["desc"]);
      },
    },
  ];
  const orderDirectionMenuProps = {
    items: orderDirectionItems,
    selectable: true,
    defaultSelectedKeys: ["desc"],
  };

  /// ------

  const [selectedUser, setSelectedUser] = useState(null);
  const [openUserModal, setOpenUserModal] = useState(false);

  useEffect(() => {
    if (selectedUser) {
      setOpenUserModal(true);
    }
  }, [selectedUser]);

  /// ------

  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageSize, setCurrentPageSize] = useState(10);
  const [hasNextPage, setHasNextPage] = useState(true);

  const [loading, setLoading] = useState(true);

  const [initLoading, setInitLoading] = useState(true);

  // eslint-disable-next-line no-unused-vars
  const [distincts, setDistincts] = useState(null);
  const [countriesMenu, setCountriesMenu] = useState([]);
  const [countries, setCountries] = useState([]);
  const [citiesMenu, setCitiesMenu] = useState([]);
  const [cities, setCities] = useState(null);
  const [schoolsMenu, setSchoolsMenu] = useState([]);
  const [schools, setSchools] = useState(null);
  const [schoolClassesMenu, setSchoolClassesMenu] = useState([]);
  const [schoolClasses, setSchoolClasses] = useState(null);
  const [professionsMenu, setProfessionsMenu] = useState([]);
  const [selectedProfessions, setSelectedProfessions] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [applicationStatusMenu, setApplicationStatusMenu] = useState([
    "PENDING",
    "APPOINTED",
    "CARRIED_OUT",
    "REJECTED",
  ]);
  const [applicationStatuses, setApplicationStatuses] = useState([
    "PENDING",
    "APPOINTED",
    "CARRIED_OUT",
    "REJECTED",
  ]);

  const [searchInput, setSearchInput] = useState("");

  useEffect(() => {
    ProfessionService.getProfessions()
      .then((r) => {
        setProfessionsList(r.data);
        setProfessionsMenu(r.data.map((prof) => prof.name));
        setSelectedProfessions(r.data.map((prof) => prof.name));
      })
      .catch(() => {});
  }, []);

  const handlePaginationChange = (page, pageSize) => {
    setCurrentPage(page);
    setCurrentPageSize(pageSize);
  };

  async function handleFetchData() {
    setLoading(true);
    await AdminApplicationService.getApplications(
      currentPage,
      currentPageSize,
      selectedOrderProperty,
      selectedOrderDirection,
      countries,
      cities,
      schools,
      schoolClasses,
      selectedProfessions,
      applicationStatuses
    )
      .then((r) => {
        setApplications(r.data.list);
        setHasNextPage(r.data.hasMore);
      })
      .catch(() => {
        message.destroy();
        message.error("error", 5);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  async function getDistincts() {
    await AdminProfileService.getDistincts()
      .then((r) => {
        setDistincts(r.data);
        setCountriesMenu(r.data.countries);
        setCountries(r.data.countries);
        setCitiesMenu(r.data.cities);
        setCities(r.data.cities);
        setSchoolsMenu(r.data.schools);
        setSchools(r.data.schools);
        setSchoolClassesMenu(r.data.schoolClasses);
        setSchoolClasses(r.data.schoolClasses);
      })
      .catch(() => {
        message.destroy();
        message.error("error", 5);
      });
  }

  useEffect(() => {
    getDistincts();
  }, []);

  useEffect(() => {
    if (
      countries &&
      cities &&
      schools &&
      schoolClasses &&
      selectedProfessions &&
      applicationStatuses
    ) {
      handleFetchData();
      setInitLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    currentPage,
    countries,
    cities,
    schools,
    schoolClasses,
    selectedProfessions,
    applicationStatuses,
  ]);

  useEffect(() => {
    if (currentPage === 1) {
      if (!initLoading) {
        handleFetchData();
      }
    } else {
      setCurrentPage(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPageSize]);

  async function handleAppointApplication() {
    const appointmentDateA = form.getFieldValue("appointmentDateA");
    const appointmentDateB = form.getFieldValue("appointmentDateB");
    const appointmentDateC = form.getFieldValue("appointmentDateC");
    const linkA = form.getFieldValue("linkA");
    const linkB = form.getFieldValue("linkB");
    const linkC = form.getFieldValue("linkC");
    const addressA = form.getFieldValue("addressA");
    const addressB = form.getFieldValue("addressB");
    const addressC = form.getFieldValue("addressC");
    form
      .validateFields()
      .then(() => {
        message.loading("loading", 0);
        AdminApplicationService.appointApplication(
          selectedRecordId,
          appointmentDateA,
          appointmentDateB,
          appointmentDateC,
          linkA ? linkA : null,
          linkB ? linkB : null,
          linkC ? linkC : null,
          addressA ? addressA : null,
          addressB ? addressB : null,
          addressC ? addressC : null
        )
          .then(() => {
            message.destroy();
            message.success("success", 5);
            handleFetchData();
            setSelectedRecordId(null);
            form.resetFields();
            setIsModalOpen(false);
          })
          .catch(() => {
            message.destroy();
            message.error("error", 5);
          });
      })
      .catch(() => {});
  }

  async function handleDownloadTemplate() {
    message.loading("loading", 0);
    await AdminUserService.downloadTemplate()
      .then((r) => {
        message.destroy();
        message.success("success", 5);
        triggerDownload(r.data, "accounts-template.xlsx");
      })
      .catch(() => {
        message.destroy();
        message.error("error", 5);
      });
  }

  async function handleDownloadApplicationReport() {
    message.loading("loading", 0);
    await AdminApplicationService.downloadApplicationReport()
      .then((r) => {
        message.destroy();
        message.success("success", 5);
        triggerDownload(r.data, "application-report.xlsx");
      })
      .catch(() => {
        message.destroy();
        message.error("error", 5);
      });
  }

  async function handleGenerateAccount(file) {
    message.loading("loading", 0);
    await AdminUserService.generateAccounts(file)
      .then((r) => {
        message.destroy();
        message.success("success", 5);
        triggerDownload(r.data, "accounts.xlsx");
      })
      .catch(() => {
        message.destroy();
        message.error("error", 5);
      });
  }

  const filteredApplications = applications.filter((record) => {
    const searchString = [
      record.user?.profile?.fullName,
      record.user?.profile?.city,
      record.user?.profile?.school,
      record.user?.profile?.schoolClass,
      record.professionPriorityA?.name,
      record.professionPriorityB?.name,
      record.professionPriorityC?.name,
    ]
      .filter(Boolean) // remove undefined/null
      .join(" ")
      .toLowerCase();

    return searchString.includes(searchInput.toLowerCase());
  });

  const items = [
    {
      label: "Жагсаалт",
      key: "applications",
      icon: <UsergroupAddOutlined />,
      item: (
        <Flex
          style={{ width: "100%" }}
          align={"flex-start"}
          justify={"flex-start"}
          vertical
          gap={20}
        >
          <MyText size={"large"} style={{ paddingLeft: 20 }} strong>
            Суралцагчийн жагсаалт
          </MyText>
          <Flex
            style={{ width: "100%", paddingLeft: 20, paddingRight: 20 }}
            align={"center"}
            justify={"flex-start"}
            gap={20}
          >
            <Button onClick={handleDownloadApplicationReport}>
              Жагсаалт татаж авах
            </Button>
          </Flex>

          <HorizontalDivider />
          <Modal
            title={"Хэрэглэгчийн профайл"}
            onCancel={() => {
              setOpenUserModal(false);
              setSelectedUser(null);
            }}
            open={openUserModal}
            onOk={() => {
              setOpenUserModal(false);
              setSelectedUser(null);
            }}
            footer={[
              <Button
                onClick={() => {
                  setOpenUserModal(false);
                  setSelectedUser(null);
                }}
              >
                OK
              </Button>,
            ]}
          >
            <Flex
              style={{ width: "100%", paddingLeft: 20, paddingRight: 20 }}
              align={"center"}
              justify={"flex-start"}
              gap={20}
            >
              <MyText strong>Овог: </MyText>
              <MyText>{selectedUser?.profile?.lastName}</MyText>
            </Flex>
            <Flex
              style={{ width: "100%", paddingLeft: 20, paddingRight: 20 }}
              align={"center"}
              justify={"flex-start"}
              gap={20}
            >
              <MyText strong>Нэр: </MyText>
              <MyText>{selectedUser?.profile?.firstName}</MyText>
            </Flex>
            <Flex
              style={{ width: "100%", paddingLeft: 20, paddingRight: 20 }}
              align={"center"}
              justify={"flex-start"}
              gap={20}
            >
              <MyText strong>Холбоо барих дугаар: </MyText>
              <MyText>{selectedUser?.profile?.contactNumber}</MyText>
            </Flex>
            <Flex
              style={{ width: "100%", paddingLeft: 20, paddingRight: 20 }}
              align={"center"}
              justify={"flex-start"}
              gap={20}
            >
              <MyText strong>И-мэйл: </MyText>
              <MyText>{selectedUser?.profile?.email}</MyText>
            </Flex>
            <Flex
              style={{ width: "100%", paddingLeft: 20, paddingRight: 20 }}
              align={"center"}
              justify={"flex-start"}
              gap={20}
            >
              <MyText strong>Төрсөн огноо: </MyText>
              <MyText>
                {selectedUser?.profile?.birthday &&
                  new Date(
                    selectedUser?.profile?.birthday
                  ).toLocaleDateString()}
              </MyText>
            </Flex>
            <Flex
              style={{ width: "100%", paddingLeft: 20, paddingRight: 20 }}
              align={"center"}
              justify={"flex-start"}
              gap={20}
            >
              <MyText strong>Хүйс: </MyText>
              <MyText>
                {selectedUser?.profile?.gender === true && "Эрэгтэй"}
              </MyText>
              <MyText>
                {selectedUser?.profile?.gender === false && "Эмэгтэй"}
              </MyText>
            </Flex>
            <Flex
              style={{ width: "100%", paddingLeft: 20, paddingRight: 20 }}
              align={"center"}
              justify={"flex-start"}
              gap={20}
            >
              <MyText strong>Улс: </MyText>
              <MyText>{selectedUser?.profile?.country}</MyText>
            </Flex>
            <Flex
              style={{ width: "100%", paddingLeft: 20, paddingRight: 20 }}
              align={"center"}
              justify={"flex-start"}
              gap={20}
            >
              <MyText strong>Хот/Аймаг: </MyText>
              <MyText>{selectedUser?.profile?.city}</MyText>
            </Flex>
            <Flex
              style={{ width: "100%", paddingLeft: 20, paddingRight: 20 }}
              align={"center"}
              justify={"flex-start"}
              gap={20}
            >
              <MyText strong>Сургууль: </MyText>
              <MyText>{selectedUser?.profile?.school}</MyText>
            </Flex>
            <Flex
              style={{ width: "100%", paddingLeft: 20, paddingRight: 20 }}
              align={"center"}
              justify={"flex-start"}
              gap={20}
            >
              <MyText strong>Анги: </MyText>
              <MyText>{selectedUser?.profile?.schoolClass}</MyText>
            </Flex>
            <Flex
              style={{ width: "100%", paddingLeft: 20, paddingRight: 20 }}
              align={"center"}
              justify={"flex-start"}
              gap={20}
            >
              <MyText strong>Төрөлх хэл: </MyText>
              <MyText>{selectedUser?.profile?.languageSkills}</MyText>
            </Flex>
            <Flex
              style={{ width: "100%", paddingLeft: 20, paddingRight: 20 }}
              align={"center"}
              justify={"flex-start"}
              gap={20}
            >
              <MyText strong>Гадаад хэл: </MyText>
              <MyText>{selectedUser?.profile?.foreignLanguageSkills}</MyText>
            </Flex>
          </Modal>
          <Modal
            title="Огноог сонгоод танилцуулгын холбоосыг бичнэ үү"
            open={isModalOpen}
            onOk={handleAppointApplication}
            onCancel={() => {
              setIsModalOpen(false);
              setSelectedRecordId(null);
            }}
          >
            <Form
              form={form}
              className={classes.form}
              style={{ justifyContent: "center" }}
            >
              <FormItem
                rules={[
                  {
                    required: true,
                    message: <IntlMessage id={"requiredField"} />,
                  },
                ]}
                label={
                  "А тэргүүлэх чиглэлийг танилцуулах огноо (" +
                  applications.find((app) => app.id === selectedRecordId)
                    ?.professionPriorityA.name +
                  ")"
                }
                labelCol={{ span: 24 }}
                className={classes.formInputBlock}
                name="appointmentDateA"
              >
                <DatePicker
                  showTime
                  style={{ width: "100%", padding: "10px 15px" }}
                  placeholder={"А тэргүүлэх чиглэлийг танилцуулах огноо"}
                />
              </FormItem>
              <FormItem
                rules={[
                  {
                    required: true,
                    message: <IntlMessage id={"requiredField"} />,
                  },
                ]}
                label={
                  "Хаяг, Сонголт 1 (" +
                  applications.find((app) => app.id === selectedRecordId)
                    ?.professionPriorityA.name +
                  ")"
                }
                labelCol={{ span: 24 }}
                className={classes.formInputBlock}
                name="addressA"
              >
                <Input
                  rootClassName={classes.formInput}
                  placeholder={"Хаяг, Сонголт 1"}
                />
              </FormItem>
              <HorizontalDivider />
              <FormItem
                rules={[
                  {
                    required: true,
                    message: <IntlMessage id={"requiredField"} />,
                  },
                ]}
                label={
                  "Б тэргүүлэх чиглэлийг танилцуулах огноо (" +
                  applications.find((app) => app.id === selectedRecordId)
                    ?.professionPriorityB.name +
                  ")"
                }
                labelCol={{ span: 24 }}
                className={classes.formInputBlock}
                name="appointmentDateB"
              >
                <DatePicker
                  showTime
                  style={{ width: "100%", padding: "10px 15px" }}
                  placeholder={"Б тэргүүлэх чиглэлийг танилцуулах огноо"}
                />
              </FormItem>
              <FormItem
                rules={[
                  {
                    required: true,
                    message: <IntlMessage id={"requiredField"} />,
                  },
                ]}
                label={
                  "Хаяг, Сонголт 2 (" +
                  applications.find((app) => app.id === selectedRecordId)
                    ?.professionPriorityB.name +
                  ")"
                }
                labelCol={{ span: 24 }}
                className={classes.formInputBlock}
                name="addressB"
              >
                <Input
                  rootClassName={classes.formInput}
                  placeholder={"Хаяг, Сонголт 2"}
                />
              </FormItem>
              <HorizontalDivider />
              <FormItem
                rules={[
                  {
                    required: true,
                    message: <IntlMessage id={"requiredField"} />,
                  },
                ]}
                label={
                  "Тэргүүлэх С танилцуулах огноо (" +
                  applications.find((app) => app.id === selectedRecordId)
                    ?.professionPriorityC.name +
                  ")"
                }
                labelCol={{ span: 24 }}
                className={classes.formInputBlock}
                name="appointmentDateC"
              >
                <DatePicker
                  showTime
                  style={{ width: "100%", padding: "10px 15px" }}
                  placeholder={"Тэргүүлэх С танилцуулах огноо"}
                />
              </FormItem>
              <FormItem
                rules={[
                  {
                    required: true,
                    message: <IntlMessage id={"requiredField"} />,
                  },
                ]}
                label={
                  "Хаяг, Сонголт 3 (" +
                  applications.find((app) => app.id === selectedRecordId)
                    ?.professionPriorityC.name +
                  ")"
                }
                labelCol={{ span: 24 }}
                className={classes.formInputBlock}
                name="addressC"
              >
                <Input
                  rootClassName={classes.formInput}
                  placeholder={"Хаяг, Сонголт 3"}
                />
              </FormItem>
            </Form>
          </Modal>
          <Flex
            style={{
              width: "100%",
              paddingLeft: 20,
              position: "relative",
              paddingRight: 20,
            }}
            align={"center"}
            justify={"flex-start"}
            gap={10}
            wrap={"wrap"}
          >
            <Search
              placeholder="Хайлт"
              allowClear
              onChange={(e) => setSearchInput(e.target.value)}
              style={{ marginBottom: 16 }}
            />

            <Dropdown.Button
              style={{ width: "auto" }}
              menu={orderMenuProps}
              icon={<FilterOutlined />}
            >
              Ангилах
            </Dropdown.Button>

            <Dropdown menu={orderDirectionMenuProps}>
              <Button>
                <Space>
                  {selectedOrderDirection[0] === "desc" ? (
                    <SortDescendingOutlined />
                  ) : (
                    <SortAscendingOutlined />
                  )}
                </Space>
              </Button>
            </Dropdown>

            <CheckboxMenu
              text={"Улс орон"}
              options={countriesMenu}
              selectedItems={countriesMenu}
              value={countriesMenu}
              onChange={(selection) => {
                setCountries(selection);
              }}
            />
            <CheckboxMenu
              text={"Хот/Аймаг"}
              options={citiesMenu}
              selectedItems={citiesMenu}
              value={citiesMenu}
              onChange={(selection) => {
                setCities(selection);
              }}
            />
            <CheckboxMenu
              text={"Сургууль"}
              options={schoolsMenu}
              selectedItems={schoolsMenu}
              value={schoolsMenu}
              onChange={(selection) => {
                setSchools(selection);
              }}
            />
            <CheckboxMenu
              text={"Анги"}
              options={schoolClassesMenu}
              selectedItems={schoolClassesMenu}
              value={schoolClassesMenu}
              onChange={(selection) => {
                setSchoolClasses(selection);
              }}
            />
            <CheckboxMenu
              text={"Мэргэжлийн чиглэл"}
              options={professionsMenu}
              selectedItems={professionsMenu}
              value={professionsMenu}
              onChange={(selection) => {
                setSelectedProfessions(selection);
              }}
            />
            <CheckboxMenuForStatus
              text={"Төлөв"}
              options={applicationStatusMenu}
              selectedItems={applicationStatusMenu}
              value={applicationStatusMenu}
              onChange={(selection) => {
                setApplicationStatuses(selection);
              }}
            />
          </Flex>
          <Flex
            style={{
              width: "100%",
              paddingLeft: 20,
              position: "relative",
              paddingRight: 20,
            }}
            align={"center"}
            justify={"flex-start"}
            gap={20}
          >
            <BlockLoading isLoading={initLoading || loading} />
            <table className={profileClasses.table}>
              <thead>
                <tr className={profileClasses.tr}>
                  <th className={profileClasses.th} style={{ width: 100 }}>
                    Огноо
                  </th>
                  <th className={profileClasses.th} style={{ width: 50 }}>
                    Профайл
                  </th>
                  <th className={profileClasses.th} style={{ width: 200 }}>
                    Аймаг/Хот
                  </th>
                  <th className={profileClasses.th} style={{ width: 200 }}>
                    Сургууль
                  </th>
                  <th className={profileClasses.th} style={{ width: 200 }}>
                    Овог нэр
                  </th>
                  <th className={profileClasses.th} style={{ width: 100 }}>
                    Анги
                  </th>
                  <th className={profileClasses.th} style={{ width: 500 }}>
                    Мэргэжлийн чиглэл
                  </th>
                  <th className={profileClasses.th}>Төлөв</th>
                  <th className={profileClasses.th}>Үйлдэл</th>
                </tr>
              </thead>
              <tbody>
                {filteredApplications.map((record, i) => (
                  <ApplicationItem
                    key={`${record.id || i}-applicationItem`}
                    i={i}
                    record={record}
                    handleFetchData={handleFetchData}
                    setIsModalOpen={setIsModalOpen}
                    setSelectedRecordId={setSelectedRecordId}
                    setSelectedUser={setSelectedUser}
                  />
                ))}
              </tbody>
            </table>
          </Flex>
          <Flex
            style={{
              width: "100%",
              paddingLeft: 20,
              position: "relative",
              paddingRight: 20,
            }}
            align={"center"}
            justify={"flex-end"}
            gap={20}
          >
            <Pagination
              current={currentPage}
              pageSize={currentPageSize}
              onChange={handlePaginationChange}
              showSizeChanger
              total={
                hasNextPage
                  ? currentPage * currentPageSize + 1
                  : currentPage * currentPageSize
              }
              pageSizeOptions={[10, 20, 50]}
              loading={loading}
            />
          </Flex>
        </Flex>
      ),
    },
    {
      label: "Сонголт",
      key: "songolt",
      icon: <CheckCircleOutlined />,
      item: (
        <Flex
          style={{ width: "100%" }}
          align="flex-start"
          justify="flex-start"
          vertical
          gap={20}
        >
          <MyText size="large" style={{ paddingLeft: 20 }} strong>
            Сонголт
          </MyText>
          <HorizontalDivider />
          <AdminSongoltPage />
        </Flex>
      ),
    },
    {
      label: "Хэрэглэгч",
      key: "accounts",
      icon: <UserOutlined />,
      item: (
        <Flex
          style={{ width: "100%" }}
          align={"flex-start"}
          justify={"flex-start"}
          vertical
          gap={20}
        >
          <MyText size={"large"} style={{ paddingLeft: 20 }} strong>
            Хэрэглэгч
          </MyText>
          <HorizontalDivider />
          <Flex
            style={{
              width: "100%",
              paddingLeft: 20,
              position: "relative",
              paddingRight: 20,
            }}
            align={"center"}
            justify={"flex-start"}
            gap={10}
          >
            <Button onClick={handleDownloadTemplate}>Загвар татаж авах</Button>

            <Upload
              showUploadList={false}
              beforeUpload={() => {
                return false;
              }}
              multiple={false}
              onChange={(info) => {
                if (info.file.status !== "removed") {
                  console.log(info);
                  handleGenerateAccount(info.file);
                }
              }}
            >
              <Button>Хэрэглэгч үүсгэх</Button>
            </Upload>
          </Flex>
        </Flex>
      ),
    },
    {
      type: "divider",
    },
    {
      label: <Link to={"/logout"}>Гарах</Link>,
      key: "logout",
      icon: <LogoutOutlined />,
      danger: true,
    },
  ];

  function triggerDownload(blob, filename) {
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename); // Set the download attribute with a filename
    document.body.appendChild(link);
    link.click();

    // Clean up and revoke the URL after download
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  return (
    <Flex
      style={{ width: "100%", position: "relative" }}
      vertical
      align={"center"}
      justify={"flex-start"}
    >
      <Header />
      <Flex
        style={{
          width: "100%",
          paddingTop: 150,
          position: "relative",
          overflow: "hidden",
          paddingBottom: 50,
        }}
        vertical
        align={"center"}
        justify={"flex-start"}
      >
        <Flex
          style={{ width: "100%", maxWidth: 1440, position: "relative" }}
          vertical
          gap={35}
          align={"center"}
          justify={"flex-start"}
        >
          <Flex
            style={{ width: "100%" }}
            align={"flex-start"}
            justify={"space-between"}
            gap={25}
          >
            <Flex
              style={{
                width: 300,
                backgroundColor: "#fafafa",
                paddingTop: 40,
                paddingBottom: 20,
              }}
              align={"center"}
              justify={"center"}
              vertical
              gap={25}
            >
              <Image preview={false} width={125} src={profileImg} />
              <Menu
                style={{
                  width: "100%",
                  backgroundColor: "#fafafa",
                  padding: 20,
                }}
                onClick={(e) => {
                  setCurrentMenu(e.key);
                }}
                selectedKeys={[currentMenu]}
                mode={"vertical"}
                items={items}
              />
            </Flex>
            <Flex
              style={{
                width: "100%",
                backgroundColor: "#fafafa",
                paddingTop: 40,
                paddingBottom: 20,
                position: "relative",
              }}
              align={"center"}
              justify={"center"}
            >
              {items.find((item) => item.key === currentMenu)?.item}
            </Flex>
          </Flex>
        </Flex>
      </Flex>
      <Footer />
    </Flex>
  );
};

const ApplicationItem = ({
  record,
  handleFetchData,
  setIsModalOpen,
  setSelectedRecordId,
  setSelectedUser,
}) => {
  async function handleFinishApplicationA(id) {
    message.loading("loading", 0);
    await AdminApplicationService.finishApplicationA(id)
      .then(() => {
        message.destroy();
        message.success("success", 5);
        handleFetchData();
      })
      .catch(() => {
        message.destroy();
        message.error("error", 5);
      });
  }
  async function handleFinishApplicationB(id) {
    message.loading("loading", 0);
    await AdminApplicationService.finishApplicationB(id)
      .then(() => {
        message.destroy();
        message.success("success", 5);
        handleFetchData();
      })
      .catch(() => {
        message.destroy();
        message.error("error", 5);
      });
  }
  async function handleFinishApplicationC(id) {
    message.loading("loading", 0);
    await AdminApplicationService.finishApplicationC(id)
      .then(() => {
        message.destroy();
        message.success("success", 5);
        handleFetchData();
      })
      .catch(() => {
        message.destroy();
        message.error("error", 5);
      });
  }

  async function handleRejectApplication(id) {
    message.loading("loading", 0);
    await AdminApplicationService.rejectApplication(id)
      .then(() => {
        message.destroy();
        message.success("success", 5);
        handleFetchData();
      })
      .catch(() => {
        message.destroy();
        message.error("error", 5);
      });
  }

  return (
    <tr className={profileClasses.tr}>
      <td className={profileClasses.td}>
        <MyText size={"small"}>
          {new Date(record.createdAt).toLocaleString()}
        </MyText>
      </td>
      <td className={profileClasses.td}>
        <Button
          style={{ width: "auto" }}
          onClick={() => {
            setSelectedUser(record.user);
          }}
        >
          <EyeOutlined />
        </Button>
      </td>
      <td className={profileClasses.td}>
        <MyText size={"small"}>{record.user?.profile?.city}</MyText>
      </td>
      <td className={profileClasses.td}>
        <MyText size={"small"}>{record.user?.profile?.school}</MyText>
      </td>
      <td className={profileClasses.td}>
        <MyText size={"small"}>{record.user?.profile?.fullName}</MyText>
      </td>
      <td className={profileClasses.td}>
        <MyText size={"small"}>{record.user?.profile?.schoolClass}</MyText>
      </td>
      <td className={profileClasses.td}>
        <MyText size={"small"}>
          <span style={{ color: clrs.blackerBlue }}>
            {record.professionPriorityA.name}
          </span>
          ,{" "}
          <span style={{ color: clrs.green }}>
            {record.professionPriorityB.name}
          </span>
          ,{" "}
          <span style={{ color: clrs.purple }}>
            {record.professionPriorityC.name}
          </span>
        </MyText>
      </td>
      <td className={profileClasses.td}>
        <MyText size="small">
          {record.status === "PENDING"
            ? "Шинэ"
            : record.status === "APPOINTED"
            ? "Урилга илгээсэн"
            : record.status === "REJECTED"
            ? "Татгалзсан"
            : "Батлагдсан"}
        </MyText>
      </td>
      <td className={profileClasses.td}>
        <MyText size={"small"}>
          <Flex
            style={{ width: "100%", position: "relative" }}
            wrap={"wrap"}
            align={"center"}
            justify={"center"}
            gap={20}
          >
            {record.status === "PENDING" && (
              <Button
                type={"primary"}
                onClick={() => {
                  setIsModalOpen(true);
                  setSelectedRecordId(record.id);
                }}
              >
                Илгээх
              </Button>
            )}
            {record.status !== "REJECTED" &&
              record.status !== "CARRIED_OUT" && (
                <Flex
                  vertical
                  gap={5}
                  style={{ width: "100%", position: "relative" }}
                  align={"center"}
                  justify={"center"}
                >
                  {record.statusProfessionA === "APPOINTED" ? (
                    <Popconfirm
                      title="Сонголт 1: Баталгаажуулах"
                      description="Сонголт 1: Баталгаажуулах?"
                      onConfirm={() => handleFinishApplicationA(record.id)}
                      onCancel={() => {}}
                      okText="Тийм"
                      cancelText="Үгүй"
                    >
                      <Button>Сонголт 1: Баталгаажуулах</Button>
                    </Popconfirm>
                  ) : (
                    <Button disabled>Сонголт 1: Баталгаажуулах</Button>
                  )}
                  {record.statusProfessionB === "APPOINTED" ? (
                    <Popconfirm
                      title="Сонголт 2: Баталгаажуулах"
                      description="Сонголт 2: Баталгаажуулах?"
                      onConfirm={() => handleFinishApplicationB(record.id)}
                      onCancel={() => {}}
                      okText="Тийм"
                      cancelText="Үгүй"
                    >
                      <Button>Сонголт 2: Баталгаажуулах</Button>
                    </Popconfirm>
                  ) : (
                    <Button disabled>Сонголт 2: Баталгаажуулах</Button>
                  )}
                  {record.statusProfessionC === "APPOINTED" ? (
                    <Popconfirm
                      title="Сонголт 3: Баталгаажуулах"
                      description="Сонголт 3: Баталгаажуулах?"
                      onConfirm={() => handleFinishApplicationC(record.id)}
                      onCancel={() => {}}
                      okText="Тийм"
                      cancelText="Үгүй"
                    >
                      <Button>Сонголт 3: Баталгаажуулах</Button>
                    </Popconfirm>
                  ) : (
                    <Button disabled>Сонголт 3: Баталгаажуулах</Button>
                  )}
                </Flex>
              )}
            {record.status !== "REJECTED" &&
              record.status !== "CARRIED_OUT" && (
                <Popconfirm
                  title="Татгалзах"
                  description="Татгалзах?"
                  onConfirm={() => handleRejectApplication(record.id)}
                  onCancel={() => {}}
                  okText="Тийм"
                  cancelText="Үгүй"
                >
                  <Button danger>Татгалзах</Button>
                </Popconfirm>
              )}
          </Flex>
        </MyText>
      </td>
    </tr>
  );
};

export default AdminProfilePage;
